module.exports = __webpack_public_path__ + "static/media/xgn.89f7a2e3.png";